import { faCircleInfo } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import {
  isCodTipoTranscricaoPreenchido,
  TIPO_ATENDIMENTO_OPCOES,
} from '../../utils/tipoAtendimentoUtils';

interface TipoAtendimentoRevisaoSectionProps {
  value: string;
  onChange: (codigo: string) => void;
  obrigatorio?: boolean;
  disabled?: boolean;
}

const TipoAtendimentoRevisaoSection: React.FC<TipoAtendimentoRevisaoSectionProps> = ({
  value,
  onChange,
  obrigatorio = true,
  disabled = false,
}) => {
  const { textStyleAccessibility, contrastMode, contrastStyle } = useAccessibility();
  const exibirObrigatorio = obrigatorio && !isCodTipoTranscricaoPreenchido(value);

  return (
    <section className="transcricao-tipo-atendimento-card">
      <Typography
        style={textStyleAccessibility}
        className="transcricao-revisao-section-title"
      >
        <strong>
          Sua solicitação é para qual tipo de atendimento?
          {exibirObrigatorio && (
            <span className="transcricao-tipo-atendimento-obrigatorio" aria-hidden="true">
              {' '}*
            </span>
          )}
        </strong>
      </Typography>

      {exibirObrigatorio && (
        <Typography
          style={textStyleAccessibility}
          className="transcricao-tipo-atendimento-aviso"
        >
          Selecione uma opção para continuar.
        </Typography>
      )}

      <RadioGroup
        className="transcricao-tipo-atendimento-radios"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        row
      >
        {TIPO_ATENDIMENTO_OPCOES.map((option) => (
          <FormControlLabel
            key={option.codigo}
            className="transcricao-tipo-atendimento-option"
            value={option.codigo}
            disabled={disabled}
            control={<Radio style={{ background: 'white', ...contrastStyle }} disabled={disabled} />}
            label={
              <span className="transcricao-item-option-label">
                <Typography component="span" style={textStyleAccessibility}>
                  {option.label}
                </Typography>
                <Tooltip
                  title={option.tooltip}
                  placement="top"
                  arrow
                  className="transcricao-item-tooltip"
                >
                  <span
                    className="transcricao-tipo-atendimento-info-trigger"
                    tabIndex={0}
                    role="button"
                    aria-label={`Informações sobre ${option.label}`}
                    onClick={(event) => event.preventDefault()}
                    onMouseDown={(event) => event.preventDefault()}
                  >
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className={contrastMode ? 'fa-icon18x18-accessibility' : 'fa-icon18x18'}
                    />
                  </span>
                </Tooltip>
              </span>
            }
          />
        ))}
      </RadioGroup>
    </section>
  );
};

export default TipoAtendimentoRevisaoSection;
